module.exports = __webpack_public_path__ + "static/defaultBlogPost-940dc567a047b861e68763c0ac5f05e0.jpg";